import TemplateFeatureContent from "template-store/components/template-feature-content/template-feature-content";
import TemplateOverviewContent from "template-store/components/template-overview-content/template-overview-content";

import ColumnsComponent from "./tabs/Columns";
import ViewsComponent from "./tabs/Views";
import AutomationsComponent from "./tabs/Automations";
import IntegrationsComponent from "./tabs/Integrations";

export const getTabsInfo = (tabsMetadata) => {
  return [
    {
      titleKey: "templateCenter.template.overview",
      component: TemplateOverviewContent
    },
    {
      titleKey: "templateCenter.template.columns",
      component: TemplateFeatureContent,
      featureTitleKey: "templateCenter.template.columns.title",
      featureDescriptionKey: "templateCenter.template.columns.description",
      //TODO: add video aria labels
      demoVideoFileName: "template_store_add_column.mp4",
      subsectionTitleKey: "templateCenter.template.columns.subsectionTitle",
      subsectionDescriptionKey: "templateCenter.template.columns.subsectionDescription",
      demoComponent: ColumnsComponent,
      demoComponentMetadata: tabsMetadata?.columns,
      templateDataFieldName: "columns"
    },
    {
      titleKey: "templateCenter.template.views",
      component: TemplateFeatureContent,
      featureTitleKey: "templateCenter.template.views.title",
      featureDescriptionKey: "templateCenter.template.views.description",
      demoVideoFileName: "template_store_views.mp4",
      subsectionTitleKey: "templateCenter.template.views.subsectionTitle",
      subsectionDescriptionKey: "templateCenter.template.views.subsectionDescription",
      demoComponent: ViewsComponent,
      demoComponentMetadata: tabsMetadata?.views,
      templateDataFieldName: "views"
    },
    {
      titleKey: "templateCenter.template.automations",
      component: TemplateFeatureContent,
      featureTitleKey: "templateCenter.template.automations.title",
      featureDescriptionKey: "templateCenter.template.automations.description",
      demoVideoFileName: "template_store_automations.mp4",
      subsectionTitleKey: "templateCenter.template.automations.subsectionTitle",
      subsectionDescriptionKey: "templateCenter.template.automations.subsectionDescription",
      demoComponent: AutomationsComponent
    },
    {
      titleKey: "templateCenter.template.integrations",
      component: TemplateFeatureContent,
      featureTitleKey: "templateCenter.template.integrations.title",
      featureDescriptionKey: "templateCenter.template.integrations.description",
      demoVideoFileName: "template_store_integrations.mp4",
      subsectionTitleKey: "templateCenter.template.integrations.subsectionTitle",
      subsectionDescriptionKey: "templateCenter.template.integrations.subsectionDescription",
      demoComponent: IntegrationsComponent,
      demoComponentMetadata: tabsMetadata?.integrations,
      templateDataFieldName: "integrations"
    }
  ];
};
